module.exports = __webpack_public_path__ + "static/media/gzhewm.452bd71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/gzhewm.jpg
// module id = 1048
// module chunks = 2